<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" title="{{ 'general.close_window' | translate }}" class="close" (click)="activeModal.close(false)">&times;</button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12 text-wrap text-break">
            {{message}}<br>
            {{message2}}
        </div>
    </div>
</div>
<div class="modal-footer text-right">
    <button *ngIf="closedAlert; else activeAlertButton" type="button" class="btn btn-blue btn-h-blue" [routerLink]="['main/alertHistory/view-alert-history', alertId]" routerLinkActive="active" (click)="activeModal.close(false)">
        {{ 'general.view' | translate }}
    </button>
    <ng-template #activeAlertButton>
        <button type="button" title="{{ 'general.view' | translate }}" class="btn btn-blue btn-h-blue" [routerLink]="['main/activeAlerts/view-alert', alertId]" routerLinkActive="active" (click)="activeModal.close(false)">
            {{ 'general.view' | translate }}
        </button>
    </ng-template>
    
</div>

    